/**
 * Mobile Product Card Color Swatch Scrolling Enhancement
 * Adds scroll arrows for mobile devices when color swatches exceed container height
 */

function initMobileSwatchScrolling() {
  // Only initialize on mobile screens
  if (window.innerWidth > 575) {
    return
  }

  // Target swatch containers within collection pages AND tabs-with-products section (both nested and mobile structures)
  document
    .querySelectorAll('.collection-grid-section .js-color-swatches, .tabs-with-products-section .js-color-swatches')
    .forEach((swatchContainer) => {
      const scrollGroup = swatchContainer.querySelector('.scrollable-swatches')
      if (!scrollGroup) return

      // Check if content overflows
      if (scrollGroup.scrollHeight > scrollGroup.clientHeight) {
        addScrollArrows(swatchContainer, scrollGroup)
      }
    })
}

function addScrollArrows(container, scrollGroup) {
  // Remove existing arrows if any
  const existingArrows = container.querySelectorAll('.swatch-scroll-arrow')
  existingArrows.forEach((arrow) => arrow.remove())

  // Create up arrow
  const upArrow = document.createElement('button')
  upArrow.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M297.4 169.4C309.9 156.9 330.2 156.9 342.7 169.4L534.7 361.4C547.2 373.9 547.2 394.2 534.7 406.7C522.2 419.2 501.9 419.2 489.4 406.7L320 237.3L150.6 406.6C138.1 419.1 117.8 419.1 105.3 406.6C92.8 394.1 92.8 373.8 105.3 361.3L297.3 169.3z"/></svg>'
  upArrow.classList.add('swatch-scroll-arrow', 'swatch-scroll-up')
  upArrow.type = 'button'
  upArrow.setAttribute('aria-label', 'Scroll up')

  // Create down arrow
  const downArrow = document.createElement('button')
  downArrow.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M297.4 470.6C309.9 483.1 330.2 483.1 342.7 470.6L534.7 278.6C547.2 266.1 547.2 245.8 534.7 233.3C522.2 220.8 501.9 220.8 489.4 233.3L320 402.7L150.6 233.4C138.1 220.9 117.8 220.9 105.3 233.4C92.8 245.9 92.8 266.2 105.3 278.7L297.3 470.7z"/></svg>'
  downArrow.classList.add('swatch-scroll-arrow', 'swatch-scroll-down')
  downArrow.type = 'button'
  downArrow.setAttribute('aria-label', 'Scroll down')

  // Insert arrows
  container.insertBefore(upArrow, scrollGroup)
  container.appendChild(downArrow)

  // Add scroll functionality
  upArrow.addEventListener('click', (e) => {
    e.preventDefault()
    scrollGroup.scrollBy({
      top: -50,
      behavior: 'smooth',
    })
  })

  downArrow.addEventListener('click', (e) => {
    e.preventDefault()
    scrollGroup.scrollBy({
      top: 50,
      behavior: 'smooth',
    })
  })

  // Update arrow visibility based on scroll position
  function updateArrowVisibility() {
    const isAtTop = scrollGroup.scrollTop === 0
    const isAtBottom = scrollGroup.scrollTop >= scrollGroup.scrollHeight - scrollGroup.clientHeight - 1

    upArrow.style.opacity = isAtTop ? '0.3' : '1'
    downArrow.style.opacity = isAtBottom ? '0.3' : '1'
    upArrow.disabled = isAtTop
    downArrow.disabled = isAtBottom
  }

  // Initial arrow state
  updateArrowVisibility()

  // Update arrow state on scroll
  scrollGroup.addEventListener('scroll', updateArrowVisibility)
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMobileSwatchScrolling)
} else {
  initMobileSwatchScrolling()
}

// Re-initialize on window resize
window.addEventListener('resize', debounce(initMobileSwatchScrolling, 250))

// Debounce utility function
function debounce(func, wait) {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

// Export for potential external use
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { initMobileSwatchScrolling }
}
